// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

export const Title = styled<any, Theme>('h4')`
  color: ${props => props.theme.tooltip.titleColor};
  font-size: 1rem;
  margin: 0 0 .5rem;
`;

export const Item = styled<any, Theme>('div')`
  color: ${props => props.theme.tooltip.contentColor};
  font-size: .875rem;
  line-height: 1.5;
  padding-left: 1rem;

  &::before {
    color: ${props => props.theme.tooltip.bulletColor};
    content:'●';
    margin: 0 .5rem 0 -1rem;
  }
`;

export default styled<any, Theme>('section')`
  background-color: ${props => props.theme.tooltip.backgroundColor};
  border: 1px solid ${props => props.theme.tooltip.borderColor};
  border-radius: ${props => props.theme.tooltip.borderRadius};
  bottom: 3rem;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  left: 50%;
  padding: 1rem;
  position: absolute;
  transform: translateX(-50%);
  user-select: none;
  width: 14rem;
  z-index: 1;

  &::after {
    background-color: ${props => props.theme.tooltip.backgroundColor};
    border-width: 1px;
    border-style: solid;
    border-color: transparent ${props => props.theme.tooltip.borderColor} ${props => props.theme.tooltip.borderColor} transparent;
    bottom: 0;
    box-shadow: 3px 3px 6px 0 rgba(0, 0, 0, 0.16);
    left: calc(50% - 1rem);
    content: '';
    display: block;
    height: 1rem;
    position: absolute;
    transform:
      translate(50%, 50%)
      rotate(45deg);
    transform-origin: center;
    width: 1rem;
  }

  *:hover & {
    color: ${props => props.theme.tooltip.contentColor};
  }
`;
